import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { BrandMark } from './BrandMark.js';
import { KVOX_BRAND } from './identity.js';
/**
 * The mark and the product name side by side, as the web app's bar shows them: an
 * inline flex row with an 8px gap, the name in the surrounding text style.
 *
 * It is a plain `span`, so a host wraps it in whatever link or typography it
 * uses for the bar title. With `showName` off it is the mark alone, still named
 * by the product name so that it is announced once.
 *
 * @example
 * ```tsx
 * <ShellAppBar brand={<BrandLockup />} ... />
 * ```
 *
 * @stability experimental
 */
export function BrandLockup({ size = 28, showName = true } = {}) {
    return (_jsxs(Box, { component: "span", sx: { display: 'inline-flex', alignItems: 'center', gap: 1 }, children: [_jsx(BrandMark, { size: size, title: showName ? undefined : KVOX_BRAND.productName }), showName ? KVOX_BRAND.productName : null] }));
}
